import { useBazaarVoice } from '@/components/blocks/ProductDetails/hooks/useBazaarVoice';
import { Box } from '@mui/material';

export const BazaarVoice = ({
	productId,
	isForStarts,
}: {
	productId: string;
	isForStarts: boolean;
}) => {
	const isBVWidgetRender = useBazaarVoice();

	return (
		<Box id={`script-body-${productId}`}>
			<div
				data-bv-show="rating_summary"
				className={`${isBVWidgetRender ? '' : 'remove-QA'} ${
					isForStarts ? 'remove-QA' : 'remove-starts'
				}`}
				data-bv-product-id={productId}
				data-bv-seo="true"
			/>
		</Box>
	);
};
